module.exports = __webpack_public_path__ + "media/goforajourney/img/our-experiencies-bddfc6efea2ef766c43cb1c1253c7d3c.jpg";